export const mapTheme = ({
  font_family_primary: primaryFont = 'inherit',
  brand_call_to_action: brandCTA = '#000000',
}) => ({
  selecteditemNoneNone: {
    borderBottomColor: brandCTA,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderLeftColor: brandCTA,
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px',
    borderRightColor: brandCTA,
    borderRightStyle: 'solid',
    borderRightWidth: '1px',
    borderTopColor: brandCTA,
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    color: '#FFFFFF',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'none',
    letterSpacing: '0rem',
    lineHeight: '1.25rem',
    fontWeight: 'normal',
    fontSize: '0.875rem',
  },
  panelcontainerNoneNone: {
    backgroundColor: '#ffffff',
    borderBottomColor: '#cccccc',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderLeftColor: '#cccccc',
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px',
    borderRightColor: '#cccccc',
    borderRightStyle: 'solid',
    borderRightWidth: '1px',
    borderTopColor: '#cccccc',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0.5rem',
    marginLeft: '0',
  },
  documentbodyNoneNone: {
    backgroundColor: '#ffffff',
  },
  bodytextDefaultNone: {
    color: '#000000',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'none',
    letterSpacing: '0rem',
    lineHeight: '1.25rem',
    fontWeight: 'normal',
    fontSize: '0.875rem',
  },
  buttonsPrimaryDefault: {
    backgroundColor: brandCTA,
    borderBottomColor: brandCTA,
    borderBottomStyle: 'none',
    borderBottomWidth: '0',
    borderLeftColor: brandCTA,
    borderLeftStyle: 'none',
    borderLeftWidth: '0',
    borderRightColor: brandCTA,
    borderRightStyle: 'none',
    borderRightWidth: '0',
    borderTopColor: brandCTA,
    borderTopStyle: 'none',
    borderTopWidth: '0',
    color: '#FFFFFF',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.03125rem',
    lineHeight: '1.25rem',
    fontWeight: 'bold',
    fontSize: '0.875rem',
  },
  buttonsPrimaryHover: {
    backgroundColor: `color-mix(in srgb, ${brandCTA}, black 10%)`,
    borderBottomColor: `color-mix(in srgb, ${brandCTA}, black 10%)`,
    borderBottomStyle: 'none',
    borderBottomWidth: '0',
    borderLeftColor: `color-mix(in srgb, ${brandCTA}, black 10%)`,
    borderLeftStyle: 'none',
    borderLeftWidth: '0',
    borderRightColor: `color-mix(in srgb, ${brandCTA}, black 10%)`,
    borderRightStyle: 'none',
    borderRightWidth: '0',
    borderTopColor: `color-mix(in srgb, ${brandCTA}, black 10%)`,
    borderTopStyle: 'none',
    borderTopWidth: '0',
    color: '#FFFFFF',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.03125rem',
    lineHeight: '1.25rem',
    fontWeight: 'bold',
    fontSize: '0.875rem',
  },
  buttonsPrimaryDisabled: {
    backgroundColor: '#e0e0e0',
    borderBottomColor: '#e0e0e0',
    borderBottomStyle: 'none',
    borderBottomWidth: '0',
    borderLeftColor: '#e0e0e0',
    borderLeftStyle: 'none',
    borderLeftWidth: '0',
    borderRightColor: '#e0e0e0',
    borderRightStyle: 'none',
    borderRightWidth: '0',
    borderTopColor: '#e0e0e0',
    borderTopStyle: 'none',
    borderTopWidth: '0',
    color: '#FFFFFF',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.03125rem',
    lineHeight: '1.25rem',
    fontWeight: 'bold',
    fontSize: '0.875rem',
  },
  buttonsSecondaryDefault: {
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: brandCTA,
    color: brandCTA,
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.03125rem',
    lineHeight: '1.25rem',
    fontWeight: 'bold',
    fontSize: '0.875rem',
  },
  captiontextDefaultNone: {
    color: '#9E9E9E',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'none',
    letterSpacing: '0rem',
    lineHeight: '1rem',
    fontWeight: 'normal',
    fontSize: '0.75rem',
  },
  headersMediumNone: {
    color: '#000000',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    letterSpacing: '0rem',
    lineHeight: '1.5rem',
    fontWeight: 'bold',
    fontSize: '1.125rem',
  },
  headersSmallNone: {
    color: '#424242',
    fontFamily: primaryFont,
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0rem',
    lineHeight: '1.25rem',
    fontWeight: 'normal',
    fontSize: '0.875rem',
  },
});
